import { z } from 'zod';
// Per-org registry of group types. `company` is the seeded, locked built-in;
// orgs add their own (workspace, team, …). snake_case = the wire contract.
export const groupTypeSchema = z.object({
    id: z.uuid(),
    organization_id: z.string(),
    key: z.string(),
    singular_name: z.string(),
    plural_name: z.string(),
    icon: z.string().nullable(),
    is_builtin: z.boolean(),
});
/** Lowercase identifier derived from the name (validated client + server). */
export const groupTypeKeySchema = z
    .string()
    .regex(/^[a-z][a-z0-9_]{0,63}$/, 'must be lowercase alphanumeric/underscore, starting with a letter');
export const createGroupTypeRequestSchema = z.object({
    key: groupTypeKeySchema,
    singular_name: z.string().trim().min(1).max(120),
    plural_name: z.string().trim().min(1).max(120),
    icon: z.string().trim().max(64).optional(),
});
export const updateGroupTypeRequestSchema = z.object({
    singular_name: z.string().trim().min(1).max(120).optional(),
    plural_name: z.string().trim().min(1).max(120).optional(),
    icon: z.string().trim().max(64).optional(),
});
// Response payloads (the `data` object inside the SuccessResponse envelope).
export const listGroupTypesResponseSchema = z.object({
    group_types: z.array(groupTypeSchema),
});
export const groupTypeResponseSchema = z.object({ group_type: groupTypeSchema });
// Max CUSTOM group types an org may create (built-in `company` is exempt); a
// raisable guardrail. Enforced in the backend API; the settings UI reads it too.
export const MAX_CUSTOM_GROUP_TYPES = 10;
// Group reporting DTOs (non-company types), snake_case wire contract shared with
// the backend so a shape drift is a compile error. Groups carry no revenue.
export const groupSummarySchema = z.object({
    group_key: z.string(),
    name: z.string().nullable(),
    events: z.number(),
    users: z.number(),
    last_seen: z.string().nullable(),
});
export const groupsListResponseSchema = z.object({
    group_type: z.string(),
    groups: z.array(groupSummarySchema),
});
export const groupTopUserSchema = z.object({
    resolved_identifier: z.string(),
    identity_id: z.string().nullable(),
    label: z.string(),
    events: z.number(),
    last_seen: z.string().nullable(),
});
export const groupTopUsersResponseSchema = z.object({
    group_type: z.string(),
    group_key: z.string(),
    users: z.array(groupTopUserSchema),
});
//# sourceMappingURL=groups.js.map